import { useEffect, useRef, useState } from "react";
import { Hex } from "viem";

type TransactionsProps = {
  txs: { current: { hash: Hex; roundtrip: number }[] };
  expandedNumTxs?: number;
};

export function Transactions({ txs, expandedNumTxs = 20 }: TransactionsProps) {
  const [numTxs, setNumTxs] = useState(expandedNumTxs);

  // Hack to make tailwind include the opacity classes in the bundle
  const opacities = [
    "opacity-100",
    "opacity-95",
    "opacity-90",
    "opacity-85",
    "opacity-80",
    "opacity-75",
    "opacity-70",
    "opacity-65",
    "opacity-60",
    "opacity-55",
    "opacity-50",
    "opacity-45",
    "opacity-40",
    "opacity-35",
    "opacity-30",
    "opacity-25",
    "opacity-20",
    "opacity-15",
    "opacity-10",
  ];

  const contentRef = useRef<HTMLDivElement>(null);
  const lastTxs = useRef<{ hash: Hex; roundtrip: number }[]>([]);

  useEffect(() => {
    const keyboardListener = (e: KeyboardEvent) => {
      if (e.key === "q") {
        setNumTxs(numTxs === expandedNumTxs ? 1 : expandedNumTxs);
      }
    };

    window.addEventListener("keydown", keyboardListener);

    const updateTransactions = () => {
      if (contentRef.current && txs.current.at(-1) !== lastTxs.current.at(-1)) {
        lastTxs.current = [...lastTxs.current, ...txs.current.slice(-numTxs)].slice(-numTxs);
        txs.current.length = 0;
        contentRef.current.innerHTML = lastTxs.current
          .toReversed()
          .map(
            (tx, i) =>
              `<p class="${opacities[Math.floor((i / numTxs) * opacities.length)]} hover:opacity-100 cursor-pointer">${tx.hash.slice(0, 6)}...${tx.hash.slice(-4)} (${tx.roundtrip}ms)</p>`,
          )
          .join("");
      }
    };

    const timer = setInterval(() => requestIdleCallback(updateTransactions, { timeout: 50 }), 50);
    return () => {
      clearInterval(timer);
      window.removeEventListener("keydown", keyboardListener);
    };
  }, [txs.current, numTxs]);

  return (
    <div className="text-right text-xs">
      Transactions (
      <button onClick={() => (numTxs === expandedNumTxs ? setNumTxs(1) : setNumTxs(expandedNumTxs))}>
        {numTxs === expandedNumTxs ? "Press Q to show less" : "Press Q to show more"}
      </button>
      )<div ref={contentRef}></div>
    </div>
  );
}
